import React, { useState } from 'react'
import { navigate } from 'hookrouter'
import { Grid } from '@material-ui/core'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import { List } from 'immutable'
import { Image } from './Image'
import type { ISlide } from 'hooks/useHomeCarousel'
import { useBreakpoints } from 'shared/hooks'
import { numberToGridEnum } from 'shared/services/NumberToGridEnum'
import { useStyles } from './HomeCarousel.styles'
import { clsx } from 'clsx'

interface ISwiperCarousel {
  slides: List<ISlide>
}

const HomeCarousel = ({ slides }: ISwiperCarousel) => {
  const classes = useStyles()
  const { isMobile } = useBreakpoints()
  const [stepSelected, setStepSelected] = useState(0)
  const slideNumber = slides.size

  return (
    <div
      className={clsx(classes.mainContainer, {
        [classes.mobileStretch]: isMobile
      })}
    >
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={50}
        slidesPerView={1}
        onSlideChange={({ realIndex }) => setStepSelected(realIndex)}
        loop
        autoplay={{
          delay: 4000,
          disableOnInteraction: false
        }}
        navigation={{
          nextEl: '.nav-next',
          prevEl: '.nav-prev'
        }}
      >
        {slides.map((item: ISlide, index: number) => (
          <SwiperSlide
            key={`slide-${index}`}
            className={clsx(classes.slide, { [classes.slideWithoutLink]: !item.link })}
            onClick={() => item.link && navigate(item.link)}
          >
            <Image
              backgroundUrl={isMobile ? item.imageUrl.mobile : item.imageUrl.desktop}
              backgroundSize={'crop'}
              height={'26.5rem'}
              className={clsx({ [classes.slideWithoutLink]: !item.link })}
            />
            <div className={classes.description}>
              <p className={clsx(classes.title, item.theme && item.theme)}>{item.title}</p>
              <p className={clsx(classes.text, item.theme && item.theme)}>{item.text}</p>
            </div>
          </SwiperSlide>
        ))}
        <Grid container direction="row" className={classes.swiperPagination}>
          {[...Array(slides.size)].map((_, index) => (
            <Grid
              xs={isMobile ? numberToGridEnum(12 / slideNumber) : numberToGridEnum((slideNumber * 2) / slideNumber)}
              item
              key={`pagination-${index}`}
            >
              <div
                className={clsx(classes.pagination, {
                  [classes.paginationActive]: index === stepSelected
                })}
              ></div>
            </Grid>
          ))}
        </Grid>
        {!isMobile && (
          <>
            <div className={clsx('nav-prev', classes.swiperButton)}>
              <div className={classes.arrow}>
                <img src="/assets/pictos/arrow-left.svg" alt="left arrow" />
              </div>
            </div>
            <div className={clsx('nav-next', classes.swiperButton)}>
              <div className={classes.arrow}>
                <img src="/assets/pictos/arrow-right.svg" alt="right arrow" />
              </div>
            </div>
          </>
        )}
      </Swiper>
    </div>
  )
}

export default HomeCarousel
